(function () {
  var DRAG_THRESHOLD = 6;
  var SWIPE_THRESHOLD = 40;

  function initDesktopGallery(scroller) {
    if (!scroller || scroller.dataset.sfpReady === 'true') return;
    scroller.dataset.sfpReady = 'true';

    var pointerId = null;
    var startX = 0;
    var startScroll = 0;
    var dragging = false;
    var moved = false;

    function isTouch(event) {
      return event.pointerType === 'touch';
    }

    scroller.addEventListener('pointerdown', function (event) {
      if (isTouch(event) || event.button !== 0) return;
      pointerId = event.pointerId;
      startX = event.clientX;
      startScroll = scroller.scrollLeft;
      dragging = true;
      moved = false;
      scroller.classList.add('is-dragging');
      scroller.setPointerCapture(event.pointerId);
    });

    scroller.addEventListener('pointermove', function (event) {
      if (!dragging || event.pointerId !== pointerId) return;
      var delta = event.clientX - startX;
      if (Math.abs(delta) > DRAG_THRESHOLD) moved = true;
      scroller.scrollLeft = startScroll - delta;
    });

    function endDrag(event) {
      if (!dragging || (event && event.pointerId !== pointerId)) return;
      dragging = false;
      pointerId = null;
      scroller.classList.remove('is-dragging');
    }

    scroller.addEventListener('pointerup', endDrag);
    scroller.addEventListener('pointercancel', endDrag);
    scroller.addEventListener('lostpointercapture', endDrag);

    scroller.addEventListener('click', function (event) {
      if (!moved) return;
      event.preventDefault();
      event.stopPropagation();
    }, true);
  }

  function syncThumbColumnHeight(root) {
    var stageEl = root.querySelector('.simple-featured-product__stage');
    var col = root.querySelector('.simple-featured-product__thumbs-col');
    if (!stageEl || !col) return;
    col.style.height = stageEl.offsetHeight + 'px';
  }

  function initMobileGallery(root) {
    if (!root || root.dataset.sfpMobileReady === 'true') return;
    root.dataset.sfpMobileReady = 'true';

    var stage = root.querySelector('[data-sfp-stage]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-sfp-thumb]'));
    if (!stage || thumbs.length < 1) return;

    var thumbsScroller = root.querySelector('.simple-featured-product__thumbs');
    var index = 0;

    function scrollThumbIntoView(thumb) {
      if (!thumbsScroller || !thumb) return;

      var thumbTop = thumb.offsetTop;
      var thumbHeight = thumb.offsetHeight;
      var viewHeight = thumbsScroller.clientHeight;
      var maxScroll = thumbsScroller.scrollHeight - viewHeight;
      var target = thumbTop - (viewHeight - thumbHeight) / 2;

      thumbsScroller.scrollTo({
        top: Math.max(0, Math.min(target, maxScroll)),
        behavior: 'smooth'
      });
    }

    function goTo(nextIndex) {
      if (!thumbs.length) return;
      index = ((nextIndex % thumbs.length) + thumbs.length) % thumbs.length;
      var thumb = thumbs[index];
      if (!thumb) return;
      var fullSrc = thumb.getAttribute('data-full-src');
      var fullSrcset = thumb.getAttribute('data-full-srcset');
      var thumbImg = thumb.querySelector('img');

      if (stage.tagName === 'IMG' && (fullSrc || thumbImg)) {
        stage.src = fullSrc || thumbImg.src;
        if (fullSrcset) stage.srcset = fullSrcset;
        if (thumbImg && thumbImg.alt) stage.alt = thumbImg.alt;
        if (stage.complete) {
          syncThumbColumnHeight(root);
        } else {
          stage.addEventListener('load', function () {
            syncThumbColumnHeight(root);
            scrollThumbIntoView(thumb);
          }, { once: true });
        }
      }

      thumbs.forEach(function (item, i) {
        item.classList.toggle('is-active', i === index);
      });

      scrollThumbIntoView(thumb);
    }

    root.addEventListener('click', function (event) {
      var prev = event.target.closest('[data-sfp-prev]');
      var next = event.target.closest('[data-sfp-next]');
      var thumb = event.target.closest('[data-sfp-thumb]');

      if (prev) {
        event.preventDefault();
        goTo(index - 1);
        return;
      }
      if (next) {
        event.preventDefault();
        goTo(index + 1);
        return;
      }
      if (thumb) {
        event.preventDefault();
        goTo(thumbs.indexOf(thumb));
      }
    });

    var swipeStartX = 0;
    var swipeing = false;
    var stageEl = root.querySelector('.simple-featured-product__stage');
    if (stageEl && thumbs.length > 1) {
      stageEl.addEventListener('touchstart', function (event) {
        if (!event.changedTouches || !event.changedTouches[0]) return;
        swipeStartX = event.changedTouches[0].clientX;
        swipeing = true;
      }, { passive: true });

      stageEl.addEventListener('touchend', function (event) {
        if (!swipeing || !event.changedTouches || !event.changedTouches[0]) return;
        var delta = event.changedTouches[0].clientX - swipeStartX;
        swipeing = false;
        if (Math.abs(delta) < SWIPE_THRESHOLD) return;
        if (delta < 0) goTo(index + 1);
        else goTo(index - 1);
      }, { passive: true });
    }

    function sync() {
      syncThumbColumnHeight(root);
    }

    if (stage.tagName === 'IMG') {
      if (stage.complete) sync();
      else stage.addEventListener('load', sync);
    } else {
      sync();
    }

    window.addEventListener('resize', sync);
  }

  function initSection(section) {
    initDesktopGallery(section.querySelector('[data-sfp-gallery]'));
    initMobileGallery(section.querySelector('[data-sfp-mobile-gallery]'));
  }

  function initAll(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-simple-featured-product]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
